import { render, staticRenderFns } from "./ReReportPopup.vue?vue&type=template&id=5c6b06b8&scoped=true&"
import script from "./ReReportPopup.vue?vue&type=script&lang=js&"
export * from "./ReReportPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b06b8",
  null
  
)

export default component.exports